import { useState, useEffect, useRef } from "react";
import { OIcon, XIcon } from "../../Icons";
import { TYPO } from "styles/Typo";
import {
  getChoicePercentage,
  getWiningIcon,
  transitionHeightStyle,
} from "../../util";
import ResultAnimaion from "./ResultAnimation";

function VoteResultTemplate({
  detailDiscussData,
  animation,
  waitingHeight,
  type,
  isBoxShadow = true,
}: {
  detailDiscussData: any;
  animation: any;
  waitingHeight: number | null;
  type: "binary" | "multiple";
  isBoxShadow?: boolean;
}) {
  const options = detailDiscussData?.options;
  const resultPercents = options.map(
    (option: any) => (option.votes / detailDiscussData.totalVotes) * 100
  );

  const winingOption = detailDiscussData?.winningOption;
  const isEquallyVoted = detailDiscussData?.isEquallyVoted;
  const addWininngOptions = isEquallyVoted
    ? options?.filter((option: any) => option.votes === winingOption?.votes)
    : [];

  const totalVotes = Number(detailDiscussData?.totalVotes);

  const [entireWidth, setEntireWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const [animatedWidths, setAnimatedWidths] = useState<number[]>(
    new Array(options?.length).fill(0)
  );

  const userChoice = detailDiscussData?.userChoice;
  const userChoiceSymbol = detailDiscussData?.userChoiceSymbol;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setEntireWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (entireWidth > 0) {
      setTimeout(() => {
        setAnimatedWidths(
          resultPercents.map((data: any) => (data / 100) * entireWidth)
        );
        setIsVisible(true);
      }, 100); // 약간의 지연 후 애니메이션 시작
    }
  }, [entireWidth]);
  //animation && {...transitionHeightStyle(isVisible, waitingHeight, 0.7, "w-full")}

  return (
    <div
      className="w-full"
      style={
        animation
          ? {
              height: isVisible
                ? waitingHeight
                  ? `${waitingHeight + 59}px`
                  : `${218}px`
                : `${waitingHeight}px`,
              transition: `height 0.6s ease-out 0.7s`,
              overflow: "hidden",
            }
          : {}
      }
    >
      <div
        className={`${
          userChoice ? "" : "pb-6"
        } pt-6 flex flex-col w-full gap-6 bg-white rounded-[24px] border border-gray15`}
        // style={{
        //   boxShadow: isBoxShadow
        //     ? "0px 0px 8px 0px rgba(0, 0, 0, 0.08)"
        //     : "none",
        //   WebkitBoxShadow: isBoxShadow
        //     ? "0px 0px 8px 0px rgba(0, 0, 0, 0.08)"
        //     : "none",
        // }}
      >
        <div className="px-6 flex flex-col gap-2">
          {options.map((data: any, index: number) => (
            <div
              key={index}
              className="flex px-4 py-[13px] rounded-[12px] bg-gray2 relative "
              ref={containerRef}
            >
              <div className="flex items-center justify-between z-[2] w-full h-full left-0 top-0 gap-2">
                <div className="flex items-center gap-[10px]">
                  <span
                    className={`${TYPO.TYPO6_MD} text-gray70 break-all`}
                    data-testid={`vote-button-${data.symbol}-text`}
                  >
                    {data.value}
                  </span>
                  <span className={`${TYPO.TYPO7_1_MD} text-gray70`}>
                    {getChoicePercentage(totalVotes, data?.votes)}
                  </span>
                </div>
                {type === "binary" ? (
                  data.symbol === "O" ? (
                    <OIcon size={13} />
                  ) : (
                    <XIcon size={13} />
                  )
                ) : (
                  <div
                    className={` bg-gray15 rounded-[6px] p-[3px] w-[18px] h-[18px] text-center flex items-center justify-center`}
                  >
                    <span
                      className={`w-[13px] justify-center  text-[13px] font-semibold font-['Pretendard'] leading-[13px] text-gray40  text-center`}
                    >
                      {(data?.symbol as string).toUpperCase()}
                    </span>
                  </div>
                )}
              </div>

              <div
                className={`absolute left-0 top-0 h-full
                ${
                  data.value === winingOption?.value ||
                  addWininngOptions?.find(
                    (option: any) => option.value === data.value
                  )
                    ? " bg-blue10 "
                    : " bg-gray15 "
                } rounded-[12px] z-[1] transition-all duration-700 ease-out`}
                style={{
                  width: `${(resultPercents?.[index] / 100) * entireWidth}px`, // 100% = entireWidth
                }}
              ></div>
            </div>
          ))}
        </div>
        <div
          className={`${
            userChoice ? "" : "hidden"
          } px-6 py-4 flex items-center gap-2 justify-center border-t border-gray20`}
        >
          <span
            className={`${TYPO.TYPO7_MD} text-gray60 whitespace-nowrap  !leading-[24px]`}
          >
            내 선택
          </span>
          <div
            className={`bg-gray15 rounded-[6px] p-[3px] w-[18px] h-[18px] text-center flex items-center justify-center`}
          >
            <span
              className={`w-[13px] justify-center text-[13px] font-semibold font-['Pretendard'] leading-[13px] text-gray40  text-center`}
            >
              {userChoiceSymbol?.toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function VoteResult({
  detailDiscussData,
  waitingHeight,
  animation,
  isBoxShadow = true,
}: {
  detailDiscussData: any;
  waitingHeight: number | null;
  mutate?: any;
  animation: any;
  isBoxShadow?: boolean;
}) {
  let type = detailDiscussData.agendaType;
  // let animation = detailDiscussData.animation;

  // useEffect(() => {
  //   console.log("useEffect");
  //   if (mutate) {
  //     mutate();
  //   }
  // }, []);

  return (
    <div className="flex justify-center items-center ">
      {/* {type === "binary" ? (
        <BinaryResult
          detailDiscussData={detailDiscussData}
          waitingHeight={waitingHeight}
          animation={animation}
        />
      ) : (
        <MultipleResult
          detailDiscussData={detailDiscussData}
          waitingHeight={waitingHeight}
          animation={animation}
        />
      )} */}
      <VoteResultTemplate
        detailDiscussData={detailDiscussData}
        waitingHeight={waitingHeight}
        animation={animation}
        type={type}
        isBoxShadow={isBoxShadow}
      />
    </div>
  );
}

{
  /** lagacy */
}
{
  /**
function BinaryResult({
  detailDiscussData,
  animation,
  waitingHeight,
}: {
  detailDiscussData: any;
  animation: any;
  waitingHeight: number | null;
}) {
  const options = detailDiscussData?.options;
  const Ooption = options?.find((option: any) => option.symbol === "O");
  const Xoption = options?.find((option: any) => option.symbol === "X");
  const totalVotes = Number(detailDiscussData?.totalVotes);
  const userChoice = detailDiscussData?.userChoice;

  const adminAnimation = detailDiscussData?.animation;
  if (animation || adminAnimation) {
    return (
      <div
        className={`${
          userChoice ? "" : "pb-5"
        }  flex flex-col w-full  bg-white rounded-[24px] gap-5`}
      >
        <ResultAnimaion
          detailDiscussData={detailDiscussData}
          waitingHeight={waitingHeight}
        />
      </div>
    );
  }

  return (
    <div
      className={`${
        userChoice ? "" : "pb-5"
      } pt-5 flex flex-col w-full  bg-white rounded-[24px] gap-5`}
    >
      <div className="py-2 px-6 flex items-center gap-2">
        <div className="flex flex-col gap-1 items-center grow flex-1">
          <OIcon size={12} />
          <span
            className={`${TYPO.TYPO5_SB} text-blue50 break-all text-center`}
          >
            {Ooption?.value}
          </span>
          <span className={`${TYPO.TYPO1_SB} text-black`}>
            {getChoicePercentage(totalVotes, Ooption?.votes)}
          </span>
        </div>
        <div className="flex flex-col gap-1 items-center grow flex-1">
          <XIcon size={12} />
          <span className={`${TYPO.TYPO5_SB} text-red50 break-all text-center`}>
            {Xoption?.value}
          </span>
          <span className={`${TYPO.TYPO1_SB} text-black`}>
            {getChoicePercentage(totalVotes, Xoption?.votes)}
          </span>
        </div>
      </div>
      <div
        className={`${
          userChoice ? "" : "hidden"
        } px-6 py-4 flex items-center gap-1 justify-center border-t border-gray20`}
      >
        <span className={`${TYPO.TYPO7_MD} text-gray60`}>내 선택</span>
        <span
          className={`${TYPO.TYPO5_1_MD} ${
            detailDiscussData?.userChoiceSymbol === "O"
              ? "text-blue50"
              : "text-red50"
          } break-keep`}
        >
          {getWiningIcon(detailDiscussData?.userChoiceSymbol)}
        </span>
      </div>
    </div>
  );
}




*/
}
{
  /**
  function MultipleResult({
  detailDiscussData,
  animation,
  waitingHeight,
}: {
  detailDiscussData: any;
  animation: any;
  waitingHeight: number | null;
}) {
  const options = detailDiscussData?.options;
  const resultPercents = options.map(
    (option: any) => (option.votes / detailDiscussData.totalVotes) * 100
  );

  const winingOption = detailDiscussData?.winningOption;
  const isEquallyVoted = detailDiscussData?.isEquallyVoted;
  const addWininngOptions = isEquallyVoted
    ? options?.filter((option: any) => option.votes === winingOption?.votes)
    : [];

  const totalVotes = Number(detailDiscussData?.totalVotes);

  const [entireWidth, setEntireWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const [animatedWidths, setAnimatedWidths] = useState<number[]>(
    new Array(options?.length).fill(0)
  );

  const userChoice = detailDiscussData?.userChoice;
  const userChoiceSymbol = detailDiscussData?.userChoiceSymbol;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      setEntireWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    if (entireWidth > 0) {
      setTimeout(() => {
        setAnimatedWidths(
          resultPercents.map((data: any) => (data / 100) * entireWidth)
        );
        setIsVisible(true);
      }, 100); // 약간의 지연 후 애니메이션 시작
    }
  }, [entireWidth]);
  //animation && {...transitionHeightStyle(isVisible, waitingHeight, 0.7, "w-full")}

  return (
    <div
      className="w-full"
      style={
        animation
          ? {
              height: isVisible
                ? waitingHeight
                  ? `${waitingHeight + 59}px`
                  : `${218}px`
                : `${waitingHeight}px`,
              transition: `height 0.6s ease-out 0.7s`,
              overflow: "hidden",
            }
          : {}
      }
    >
      <div
        className={`${
          userChoice ? "" : "pb-6"
        } pt-6 flex flex-col w-full gap-6 bg-white rounded-[24px]`}
      >
        <div className="px-6 flex flex-col gap-2">
          {options.map((data: any, index: number) => (
            <div
              key={index}
              className="flex px-4 py-3 rounded-[12px] bg-gray2 relative "
              ref={containerRef}
            >
              <div className="flex items-center justify-between z-[2] w-full h-full left-0 top-0 gap-2">
                <div className="flex items-center gap-[10px]">
                  <span className={`${TYPO.TYPO6_MD} text-gray70 break-all`}>
                    {data.value}
                  </span>
                  <span className={`${TYPO.TYPO7_1_MD} text-gray70`}>
                    {getChoicePercentage(totalVotes, data?.votes)}
                  </span>
                </div>

                <div
                  className={` bg-gray15 rounded-[6px] p-[3px] w-[18px] h-[18px] text-center flex items-center justify-center`}
                >
                  <span
                    className={`w-[13px] justify-center  text-[13px] font-semibold font-['Pretendard'] leading-[13px] text-gray40  text-center`}
                  >
                    {(data?.symbol as string).toUpperCase()}
                  </span>
                </div>
              </div>

              <div
                className={`absolute left-0 top-0 h-full
                ${
                  data.value === winingOption?.value ||
                  addWininngOptions?.find(
                    (option: any) => option.value === data.value
                  )
                    ? " bg-blue10 "
                    : " bg-gray15 "
                } rounded-[12px] z-[1] transition-all duration-700 ease-out`}
                style={{
                  width: `${(resultPercents?.[index] / 100) * entireWidth}px`, // 100% = entireWidth
                }}
                // style={{
                //   width: `${animatedWidths[index]}px`,
                // }}
              ></div>
            </div>
          ))}
        </div>
        <div
          className={`${
            userChoice ? "" : "hidden"
          } px-6 py-4 flex items-center gap-2 justify-center border-t border-gray20`}
        >
          <span
            className={`${TYPO.TYPO7_MD} text-gray60 whitespace-nowrap  !leading-[24px]`}
          >
            내 선택
          </span>
          <div
            className={`bg-gray15 rounded-[6px] p-[3px] w-[18px] h-[18px] text-center flex items-center justify-center`}
          >
            <span
              className={`w-[13px] justify-center text-[13px] font-semibold font-['Pretendard'] leading-[13px] text-gray40  text-center`}
            >
              {userChoiceSymbol?.toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
  
  */
}

export default VoteResult;
